import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { TdLoadingService } from '@covalent/core';
import { environment } from '../../../../../environments/environment';
import { MsdaSideNavService } from '../../../../msda-sidenav/service/msda-sidenav.service';
import { AuthService } from '../../../../services/auth.service';
import { Municipality } from '../../../../services/Municipality';
import { MunicipalityService } from '../../../../services/municipality.service';

@Component({
    selector: 'app-admin-header',
    templateUrl: './admin-header.component.html',
    styleUrls: ['./admin-header.component.scss']
})
export class AdminHeaderComponent implements OnInit {
    municipControl: FormControl = new FormControl();
    municipName: string = '';
    clients: any;
    public municipality: Municipality;
    userName: string;
    constructor(
        private _router: Router,
        private _authService: AuthService,
        private _loadingService: TdLoadingService,
        private _municipalityService: MunicipalityService,
        private _sidenavService: MsdaSideNavService
    ) { }

    ngOnInit() {
        this.getUserData();
    }
    logout() {
        this._loadingService.register();
        this._authService
            .logout()
            .finally(() => {
                this._loadingService.register();
            })
            .subscribe(() => {
                localStorage.removeItem('private-token')

                document.location.href = `${this.ssoUrl}/private/auth/login?redirectUrl=${document.location.href}`;

                // this._router.navigate(['/home']).then(() => location.reload());
            });
    }
    getUserData() {
        this._authService.sessionData.subscribe((res) => {
            this.clients =
                res && res.clients ? this.filterClients(res.clients) : null;
            this._municipalityService.currentMunicipality.subscribe((data) => {
                this.municipControl.setValue(String(data.clientId));
                this.municipName = data.fullName;
                this.municipality = data;
            });
            this.userName =
                res &&
                    res.personInfo &&
                    res.personInfo.userInput &&
                    res.personInfo.userInput.firstName &&
                    res.personInfo.userInput.lastName
                    ? `${res.personInfo.userInput.firstName} ${res.personInfo.userInput.lastName}`
                    : '';
        });
    }
    get redirectUrlForPasswordChange(): string {
        return document.location.href;
    }
    get currentLocation(): string {
        return document.location.href;
    }
    get clientsArr() {
        return Object.keys(this.clients);
    }
    selectMunicip(e: any) {
        this._municipalityService.changeClient(Number(e.value));
        location.reload();
    }
    getClientFlag(clientId: any) {
        return this._municipalityService.municipalityFlag(clientId);
    }
    getClientName(clientId: any) {
        return this._municipalityService.municipalityName(clientId);
    }
    filterClients(clients: any) {
        const validClients: any = {};
        for (const key in clients) {
            if (clients[key].applications && clients[key].applications.PT) {
                validClients[key] = clients[key];
            }
        }
        return validClients;
    }
    getClientValue(client: string) {
        return this.clients[client];
    }
    getValueForFormControl(clientId) {
        return { clientId, value: this.clients[clientId] };
    }
    openSidenav() {
        this._sidenavService.open()
    }
    get ssoUrl() :string {
        return environment.ssoUrl
    }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/admin-header/admin-header.component.ts